import Vue from 'vue'
import store from '@/store'
import router from '@/router'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

axios.interceptors.request.use((request) => {
  store.commit('setProgress', true);
  return request;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if ([401,403,404].includes(error.response.status)) {
    sessionStorage.removeItem('access_token');
    Vue.axios.defaults.headers.common['Access-Token'] = null;
    store.commit('setProgress', false);
    router.push({ name: 'Error' });
  }
  return Promise.reject(error);
});